import { render, staticRenderFns } from "./BlogFile.vue?vue&type=template&id=1bc90729&"
import script from "./BlogFile.vue?vue&type=script&lang=ts&"
export * from "./BlogFile.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports